import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import {setWindowSizeAction, setHashAction, setNavStateAction} from "./actions/SettingsAction";

import {NAV_FIXED_WHERE_SCROLL} from "./helpers/consts";
import d3plus from "./helpers/d3plus";
import {isLoggedIn} from './helpers/security';

import Loading from "./components/Loading";
import Nav from "./components/nav/Nav";
import ContactUs from "./components/items/ContactUs";

import MapViewLayout from './layouts/MapViewLayout';
import PageViewLayout from './layouts/PageViewLayout';
import LoginViewLayout from './layouts/LoginViewLayout';

import {withRouter} from 'react-router-dom';

import './App.css';

class App extends Component {

  constructor(props) {
    super(props);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.updateHash = this.updateHash.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.isPageChange = this.isPageChange.bind(this);
    this.getPageFromParams = this.getPageFromParams.bind(this);
  }

  getChildContext() {
    return {d3plus};
  }

  async componentDidMount() {
    const {history} = this.props;
    //Save initial hash
    const page = this.getPageFromParams();
    //const canSee = await isLoggedIn();
    const canSee = true;
    if (page && canSee){
      if(page==="/login"){
        history.push('?page=/page/home');
      } else {
        this.updateHash(page);
      }
    } else {
      if(canSee){
        history.push('?page=/page/home');
      }else {
        history.push('?page=/login');
      }
    }

    //Add listeners
    window.addEventListener("resize", this.updateWindowDimensions);
    window.addEventListener('scroll', this.handleScroll);

  }

  getPageFromParams() {
    const {search} = this.props.location;
    return new URLSearchParams(search.replace('?','')).get("page");
  }

  componentDidUpdate(prevProps) {
    const page = this.getPageFromParams();
    this.updateHash(page);
  }

  updateWindowDimensions() {
    const {setWindowSizeAction} = this.props;
    setWindowSizeAction({width: window.innerWidth, height: window.innerHeight});
  }

  updateHash(page) {
    const {setHashAction, hash} = this.props;
    if (this.isPageChange(hash, page)){
      window.scrollTo(0, 0); //move to top
    }
    if(hash !== page){
      setHashAction(page);
    }
  }

  isPageChange(oldHash, newHash){
    if (!oldHash || !newHash){
      return true;
    }
    const partsOld = oldHash.split('/');
    const partsNew = newHash.split('/');
    return partsOld[2] !== partsNew[2];
  }

  handleScroll(event) {
    const mustBeFixed = window.scrollY > NAV_FIXED_WHERE_SCROLL;
    const {navFixed, setNavStateAction} = this.props;
    if (mustBeFixed !== navFixed){
      setNavStateAction(mustBeFixed);
    }
  }

  componentWillUnmount (){
    window.removeEventListener("resize", this.updateWindowDimensions);
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const {hashParts} = this.props;
    return (
      <div id="fow-app" className={`fow-app-${hashParts.type}`}>
        <div id="fow-container">
          <Loading />
          {hashParts.type === "login" &&
            <>
              <LoginViewLayout />
            </>
          }
          {hashParts.type !== "login" &&
            <>
              <Nav />
              {hashParts.type === "page" && <PageViewLayout />}
              {hashParts.type === "map" && <MapViewLayout />}
              <ContactUs />
            </>
          }
        </div>
      </div>
    );
  }
}

App.childContextTypes = {
  d3plus: PropTypes.object
};

const mapStateToProps = state => {
  return {
    hash: state.settings.hash,
    hashParts: state.settings.hashParts,
    loading: state.db.loading,
    db: state.db,
    navFixed: state.settings.navFixed
  };
};
const mapDispatchToProps = dispatch => ({
  setWindowSizeAction: (dimensions) => dispatch(setWindowSizeAction(dimensions)),
  setHashAction: (hash) => dispatch(setHashAction(hash)),
  setNavStateAction: (fixed) => dispatch(setNavStateAction(fixed))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));

